import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { SolicitacaoService } from 'src/app/core/services/solicitacao.service';
import { Associado } from 'src/app/shared/models/associado';
import { Solicitacao } from 'src/app/shared/models/solicitacao';

@Component({
  selector: 'app-associado-alteracao-exibir',
  templateUrl: './associado-alteracao-exibir.component.html',
  styleUrls: ['./associado-alteracao-exibir.component.css']
})
export class AssociadoAlteracaoExibirComponent implements OnInit {

  associados: Associado;
  solicitacao: Solicitacao;
  codigo_pessoa;
  codigo_solicitacao;
  breadCrumb;
  carregando;
  listaAlteracao: any = {};

  constructor(private appComponent: AppComponent,
              private solicitacaoService: SolicitacaoService) {

  }

  ngOnInit() {
    this.breadCrumb = [ 
      {nome: "Associados", caminho: "/associado-exibir"}
    ];
    this.appComponent.setTitulo('Lista de Alterações Realizadas');
    this.appComponent.setBreadcrumb(this.breadCrumb);
    this.listar();
  }

  definirCodigo(codigo_pessoa, codigo_solicitacao) {
    this.codigo_pessoa = codigo_pessoa;
    this.codigo_solicitacao = codigo_solicitacao;
    //console.log('Definir codigo ' + codigo_solicitacao);
    //this.obter(codigo_solicitacao);
  }

  obter(codigo_solicitacao): void {
    this.solicitacao = null;
    this.solicitacaoService.find(codigo_solicitacao).subscribe((data: Solicitacao) => 
    { 
      this.solicitacao = data;
      console.log(this.solicitacao);
      
    }, error => console.log(error));
  }

  listar(): void {
    this.solicitacaoService.realizadas().subscribe((data: Associado) => 
    { 
      this.associados = data;
    }, error => console.log(error));
  }

}
